import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ExerciseService } from '../exercise.service';

import { of } from "rxjs";

@Injectable()
export class SkillsResolver implements Resolve<Observable<string>> {

    constructor(private exerciseService: ExerciseService) { }

    resolve() {
        return this.exerciseService.getExerciseSkills().catch(() => {
            return of('error');
        });
    }

}

